module.exports = "/_next/static/images/processing-time-trend-d96a01350916c9731fa80411050ad900.png";